const firebaseConfig = {
  apiKey: "AIzaSyADf2gMi2mR9G_zJSSZocZkkBNbcqZEkGo",
  authDomain: "droom-7efee.firebaseapp.com",
  databaseURL: "https://droom-7efee.firebaseio.com",
  projectId: "droom-7efee",
  storageBucket: "",
  messagingSenderId: "340923415235",
  appId: "1:340923415235:web:3393d756b6368f85"
};

// const firebaseConfig = {
//   apiKey: "AIzaSyD5GeVZJ00Ggrc8tRPFibJpCAGvLXO_0g4",
//   authDomain: "droom-test.firebaseapp.com",
//   databaseURL: "https://droom-test.firebaseio.com",
//   projectId: "droom-test",
//   storageBucket: "droom-test.appspot.com",
//   messagingSenderId: "698995312782",
//   appId: "1:698995312782:web:801defbf980e8047"
// };
export default firebaseConfig;

